/**
 * @file TileShadeField.tsx
 * @description «Затемнение» фото у плиток «Текст поверх фото» (phase19.16,
 * партия SB120, этап 3б; uiux-sb120-stage3 §3 «Плитки и категории»; данные
 * db-design-sb120-stage3 §1 `tiles.shade`): 0–80 %, «↺» — умолчание набора
 * текста (`tileShadeDefault`: светлый 45, тёмный 0) снимает ключ; градиент
 * сверху вниз сохраняет прежнюю форму 45/10/35. Светлый текст без
 * затемнения при фото — предупреждение shared под полем (не запрет).
 */

import { SECTION_LOOK_LIMITS, tileShadeDefault, type TileTone } from "@chaiberi/shared";

import { NumberSliderField } from "../../../site-fields/NumberSliderField";
import { ElementWarningNote } from "../fields/ElementWarningNote";
import { useSectionForm } from "../section-form-context";

const S = SECTION_LOOK_LIMITS.tileShade;

export const TILE_SHADE_HINT = "Тень на фото под текстом: сверху и снизу темнее, в середине светлее.";

interface Props {
  tone: TileTone;
  value: number | undefined;
  onChange: (shade: number | undefined) => void;
  /** Путь элемента — предпросмотр и предупреждение `…shade`. */
  path: string;
}

export function TileShadeField({ tone, value, onChange, path }: Props) {
  const { preview } = useSectionForm();
  const def = tileShadeDefault(tone);
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <NumberSliderField
        label="Затемнение"
        integer
        value={value}
        inherit={{ value: def, label: `как у набора · ${def} %` }}
        min={S.min}
        max={S.max}
        step={1}
        largeStep={10}
        unit="%"
        presets={[
          { label: "Нет 0", value: 0 },
          { label: "45", value: 45 },
          { label: "70", value: 70 },
        ]}
        hint={TILE_SHADE_HINT}
        onChange={onChange}
        onPreview={(v) => preview(`${path}.shade`, v)}
      />
      <ElementWarningNote path={`${path}.shade`} />
    </div>
  );
}
